<mat-list>
    <mat-list-item>
        <span mat-line>
            <button mat-icon-button [matMenuTriggerFor]="groupsMenu" type="button" class="text-right">
                <mat-icon>add</mat-icon>
            </button>
            <mat-menu #groupsMenu="matMenu">
                <ng-container *ngFor="let group of observableOfGroups | async">
                    <button *ngIf="notInList(group)" mat-menu-item (click)="addGroup(group)">{{group.Title}}</button>
                </ng-container>

            </mat-menu>
        </span>
    </mat-list-item>
    <mat-list-item *ngFor="let group of List">
        <mat-icon matListItemIcon>group_work</mat-icon>
        <h4 matListItemTitle>{{group.Title}}</h4>
        <p matListItemLine>{{group.Description}}</p>
        <button mat-icon-button type="button" class="text-right" (click)="removeGroup(group)">
            <mat-icon>delete</mat-icon>
        </button>
    </mat-list-item>
</mat-list>
